import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';
import Neutral from './Neutral';

export default {
  Warning,
  Error,
  Success,
  Info,
  Neutral,
};

export const WarningInpage = Warning;
export const ErrorInpage = Error;
export const SuccessInpage = Success;
export const InfoInpage = Info;
export const NeutralInpage = Neutral;
